import styles from './Account.module.css';
import Icon from './Icon';

/**
 * Small "Need help?" card shown at the bottom of the Overview / Billing tabs.
 * Links to the existing contact page - no new support channel introduced.
 */
export default function SupportCard({ onContact }) {
  return (
    <section className={`${styles.card} ${styles.supportCard}`}>
      <div className={styles.supportInner}>
        <div className={styles.supportIcon} aria-hidden="true"><Icon name="lifebuoy" size={20} /></div>
        <div className={styles.supportText}>
          <div className={styles.supportTitle}>Need help?</div>
          <div className={styles.supportDesc}>Have questions about your subscription or billing? We're happy to help.</div>
        </div>
        <button className={styles.btnGhost} onClick={onContact}>Contact support</button>
      </div>
    </section>
  );
}
